export function Badge({ value }) {
  if (value == null || value === '') return null
  return (
    <span className="shrink-0 min-w-[18px] h-[18px] rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center px-1 leading-none">
      {value}
    </span>
  )
}
